import { Injectable } from '@angular/core';
import { RequestCredencialesConvenio,RequestCredencialesExterno } from '../model/request_credenciales';
import { AuditoriaBeanM } from '../model/auditoria_bean';
import { environment } from '../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesService {

  constructor() { }

  getCredencialesConvenio(){
    let requestCredenciales = new RequestCredencialesConvenio();

    requestCredenciales.usuario = environment.usuarioConstancias;
    requestCredenciales.clave = environment.claveConstancias;
    return requestCredenciales;
  }

  getCredencialesGestionUsuario(){
    let requestCredenciales = new RequestCredencialesExterno();

    requestCredenciales.usuario = environment.usuarioConstancias;
    requestCredenciales.clave = environment.claveConstancias;
    return requestCredenciales;
  }

  getAuditoriaServicio(p_proceso:String){
    let auditoriaBeanM = new AuditoriaBeanM();
    let txt_c_usuario = localStorage.getItem("c_usuario");

    auditoriaBeanM.b_aud = p_proceso;
    auditoriaBeanM.c_aud_uid = txt_c_usuario;
    auditoriaBeanM.n_aud_mcaddr = "mac";
    auditoriaBeanM.c_aud_pc="pc";
    auditoriaBeanM.c_aud_uidred="ured";
    auditoriaBeanM.n_aud_ip="ip";
    return auditoriaBeanM;
  }

  getC_usuario(){
    let txt_c_usuario = localStorage.getItem("c_usuario");
    return txt_c_usuario;
  }
  getC_usuario_firma(){
    let txt_c_usuario = localStorage.getItem("c_usuario_firma");
    return txt_c_usuario;
  }
  getX_usuario(){
    let txt_c_usuario = localStorage.getItem("x_usuario");
    return txt_c_usuario;
  }

  getC_organo(){
    let txt_c_usuario = localStorage.getItem("c_organo");
    return txt_c_usuario;
  }

  getC_perfil(){
    let txt_c_usuario = localStorage.getItem("c_perfil");
    return txt_c_usuario;
  }

}
